<!-- Revised on 2025/05/13 by mnavarro -->
<template>
  <aside id="sidenav-main" class="my-3 overflow-auto border-0 sidenav navbar navbar-vertical navbar-expand-xs border-radius-xl ms-3 bg-white fixed-start ms-3">
    <div class="sidenav-header">
      <i id="iconSidenav" class="top-0 p-3 cursor-pointer fas fa-times text-secondary opacity-5 position-absolute end-0 d-none d-xl-none" aria-hidden="true"></i>
      <router-link class="m-0 navbar-brand" to="/">
        <img :src="Logo" class="navbar-brand-img h-20 w-20" alt="main_logo" />
        <span style="font-size: 24px; vertical-align: middle; color: #4A7062;" class="ms-4 font-weight-bold logo-text-arial">{{ $t('key_sidenav_app_name_p') }}</span>
        <span style="font-size: 24px; vertical-align: middle; color: #4A7062;" class="font-weight-bold logo-text-cascadia">{{ $t('key_sidenav_app_name_i') }}</span>
        <span style="font-size: 24px; vertical-align: middle; color: #4A7062;" class="font-weight-bold logo-text-arial">{{ $t('key_sidenav_app_name_cko') }}</span>
      </router-link>
    </div>
    <hr class="mt-0 horizontal dark" />
    <sidenav-list :card-bg="customClass" />
  </aside>
</template>

<script>

  import Logo from "@/assets/img/logos/picko-logo/picko.png";
  import SidenavList from "./components/SidenavList.vue";
  
  export default {
    name: "Sidenav",
    components: {
      SidenavList
    },
    props: {
      customClass: {
        type: String,
        default: ""
      }
    },
    data() {
      return {
        Logo,
      };
    },
  };

</script>

<style scoped>

  .logo-text-arial {
    font-family: 'Arial', sans-serif;
    font-size: 2rem;
  }

  .logo-text-cascadia {
    font-family: 'Cascadia Code';
    font-size: 2rem;
  }

  #sidenav-main {
    overflow: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  #sidenav-main::-webkit-scrollbar {
    display: none;
  }

</style>